module.exports = __webpack_public_path__ + "static/media/Right@3x.a009e1ad.png";